import { setThreadClosedMutation } from "@/app/Threads/GraphQL/threadMutations";
import { useThreadMutation } from "@/app/Threads/hooks/useThreadMutation";

export function useSetThreadClosed() {
  return useThreadMutation(setThreadClosedMutation);
}
